import Tag from '../../../components/core/Tag';
import { IProductAnnouncementTag } from '../../../interfaces/IProductAnnouncement';
import colors from '../../../theme/colors';

const AnnouncementTag = ({ tag }: { tag: IProductAnnouncementTag }) => {
  switch (tag) {
    case IProductAnnouncementTag.AMP:
      return <Tag label="AMP" textColor={colors.white} backgroundColor={colors.purple400} />;
    case IProductAnnouncementTag.Quoting:
      return <Tag label="Quoting" textColor={colors.white} backgroundColor={colors.cherise} />;
    case IProductAnnouncementTag.Telephony:
      return <Tag label="Telephony" textColor={colors.white} backgroundColor={colors.orange400} />;
    case IProductAnnouncementTag.News:
      return <Tag label="News" textColor={colors.black} backgroundColor={colors.neutral100} />;
    case IProductAnnouncementTag.Features:
      return <Tag label="Features" textColor={colors.black} backgroundColor={colors.neutral100} />;
    case IProductAnnouncementTag.TipsAndGuides:
      return <Tag label="Tips and guides" textColor={colors.black} backgroundColor={colors.neutral100} />;
    default:
      return <Tag label="AMP" textColor={colors.black} backgroundColor={colors.neutral100} />;
  }
};

export default AnnouncementTag;
